export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 50 },
];

export const initialFilter = {
  filter: {
    name: "",
  },
  pageNumber: 1,
  pageSize: 10,
};

export const benefisType = [
  {
    value: "ORGANISASI",
    name: "ORGANISASI",
  },
  {
    value: "INDIVIDU",
    name: "INDIVIDU",
  },
];

export const isAlive = [
  {
    value: true,
    name: "Hidup",
  },
  {
    value: false,
    name: "Meninggal",
  },
];

export const isActive = [
  {
    value: true,
    name: "Aktif",
  },
  {
    value: false,
    name: "Non Aktif",
  },
];

export const jenisKelamin = [
  {
    value: "L",
    name: "Pria",
  },
  {
    value: "P",
    name: "Wanita",
  },
];

export const pendidikan = [
  {
    value: "SD",
    name: "SD",
  },
  {
    value: "SMP",
    name: "SMP",
  },
  {
    value: "SMA",
    name: "SMA",
  },
  {
    value: "S1",
    name: "S1",
  },
  {
    value: "S2",
    name: "S2",
  },
  {
    value: "S3",
    name: "S3",
  },
];
